import React from "react";

export default function Sport() {
  return (
    <div className="container-fluid py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Sport</h1>
          <p className="text-muted">Track your fitness and activities</p>
        </div>
      </div>
    </div>
  );
}
